export default __webpack_public_path__ + "static/media/50.22f66eaf.jpg";